import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Row, Col, Image } from "react-bootstrap";
import moment from "moment";
import momentTimezone from "moment-timezone";
import PropTypes from "prop-types";
import { changeTimzone } from "./../../helpers/stubs";
import { deleteScreenshot } from "../../Slices/candidateSlice";

function ImageCard(props) {
  const {
    screenshotId,
    url,
    lowResUrl,
    setfShowCarousel,
    screenShotImageIndex,
    setcurrentIndexOfSessionForCrousal,
    setcurrentIndexOfScreenshotForCrousal,
    timeTakenAt,
    sessions,
    sessionIndex: sessionIndexProp,
    selectedDay,
    userId,
    showDeleteButton,
    timezone,
  } = props;
  const dispatch = useDispatch();

  const onClickImage = () => {
    let sessionIndex = sessionIndexProp;
    if (sessionIndex === 0) {
      setcurrentIndexOfScreenshotForCrousal(screenShotImageIndex);
    } else {
      let numberOfPreviousImages = 0;
      // eslint-disable-next-line no-plusplus
      sessionIndex--;
      while (sessionIndex >= 0) {
        console.log(sessions, "sessions");
        numberOfPreviousImages += sessions[sessionIndex].screenshots.length;
        // eslint-disable-next-line no-plusplus
        sessionIndex--;
      }
      setcurrentIndexOfScreenshotForCrousal(
        numberOfPreviousImages + screenShotImageIndex
      );
    }
    setcurrentIndexOfSessionForCrousal(sessionIndex);
    setfShowCarousel(true);
  };

  const deleteScreenshotImage = () => {
    dispatch(deleteScreenshot({ screenshotId, userId, day: selectedDay }));
  };

  return (
    <div
      key={String(Math.random())}
      className="col-sm-6 col-md-4 col-lg-3 mb-2 m-2"
    >
      <div className="mr-2">  
        <Row>
          <Col sm="7">
            {changeTimzone(timeTakenAt, timezone)
              .format("h:mm a")
              .toUpperCase()}
          </Col>
          {showDeleteButton && (
            <Col className="text-end">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="red"
                className="bi bi-trash"
                viewBox="0 0 16 16"
                onClick={deleteScreenshotImage}
                style={{ cursor: "pointer" }}
              >
                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                <path
                  fillRule="evenodd"
                  d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                />
              </svg>
            </Col>
          )}
        </Row>
        <Row>
          <Image
            onClick={onClickImage}
            src={lowResUrl}
            className="p-0"
            thumbnail
            rounded
          />
        </Row>
      </div>
    </div>
  );
}

ImageCard.propTypes = {
  url: PropTypes.string.isRequired,
  setfShowCarousel: PropTypes.func.isRequired,
  screenShotImageIndex: PropTypes.number.isRequired,
  setcurrentIndexOfSessionForCrousal: PropTypes.func.isRequired,
  setcurrentIndexOfScreenshotForCrousal: PropTypes.func.isRequired,
  timeTakenAt: PropTypes.instanceOf(Date).isRequired,
  sessions: PropTypes.instanceOf(Array).isRequired,
  sessionIndex: PropTypes.number.isRequired,
};
export default ImageCard;
